export default __webpack_public_path__ + "static/media/unicorn.4edb0128.png";